"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var SupportAndInfo = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(SupportAndInfo, _window$AbstractView);

    var _super = _createSuper(SupportAndInfo);

    function SupportAndInfo(id, options) {
      _classCallCheck(this, SupportAndInfo);

      return _super.call(this, id, options);
    }

    _createClass(SupportAndInfo, [{
      key: "init",
      value: function init() {
        var _this = this;

        /* PARSE URLS */
        this._genCondUrls = ["general-conditions"];
        $("#genaral-conditions__accordion .card").each(function (i, el) {
          _this._genCondUrls.push($(el).attr("data-ref-hash").replace("#", ""));
        });
        /*this._faqUrls = ["faq"];
        $("#faq__accordion .card").each((i, el) => {
            this._faqUrls.push($(el).attr("data-ref-hash").replace("#", ""));
        });*/

        this._genCondUrls = this._genCondUrls.join("|"); // this._faqUrls = this._faqUrls.join("|");

        /**/

        this.$supportTab = this.$domElement.find('#support-and-info__tab-nav a[aria-controls="support-and-info__support"]');
        this.$conditionsTab = this.$domElement.find('#support-and-info__tab-nav a[aria-controls="support-and-info__general-conditions"]'); // this.$faqTab = this.$domElement.find('#support-and-info__tab-nav a[aria-controls="support-and-info__faq"]');
        // this.$faqAccordion = this.$domElement.find('#faq__accordion');

        this.$generalConditionsAccordion = this.$domElement.find('#genaral-conditions__accordion');
        /**/

        this.$accordion = this.$domElement.find(".support-and-info__accordion");
        this.$collapse = this.$accordion.find(".collapse");
        this.$toggleCollapse = this.$accordion.find('a[data-toggle="collapse"]');
        this.$tabNavA = this.$domElement.find("#support-and-info__tab-nav a[ref-hash]");
        /**/

        this.$tabNavA.on("click." + this.id, function (event) {
          // click on the tab buttons
          event.stopPropagation();
          event.preventDefault();
          window.location.hash = $(event.delegateTarget).attr("ref-hash");
        });
        $(window).off("hashchange." + this.id).on("hashchange." + this.id, function (event) {
          _this.updateAccordion();
        });
        this.$toggleCollapse.on("click." + this.id, function (event) {
          event.preventDefault();
          event.stopPropagation();
          /* if already open, close it */

          var $relCollapse = _this.$accordion.find(".collapse" + $(event.delegateTarget).attr("href"));

          if ($relCollapse.hasClass("show")) {
            window.location.hash = "";
            $relCollapse.collapse('hide');
            TweenMax.to(window, 0.65, {
              scrollTo: {
                y: 0,
                autoKill: false
              },
              ease: Cubic.easeOut
            });
            return;
          }
          /* Set the location hash according the parent card */


          window.location.hash = $(event.delegateTarget).closest(".card").attr('data-ref-hash');
        });
        /**/

        var LINE_HEIGHT = $(this.$accordion.find(".card-header")[0]).outerHeight();
        var TOP_GAP = 0;
        this.$collapse.on('shown.bs.collapse', function (event) {
          TweenMax.to(window, 0.65, {
            scrollTo: {
              y: $($(event.delegateTarget).closest(".card")).offset().top - siteHeader.currentHeight - TOP_GAP,
              autoKill: false
            },
            ease: Cubic.easeOut
          });
        });

        _get(_getPrototypeOf(SupportAndInfo.prototype), "addModules", this).call(this, new SupportForm("support-and-info__support__form", {
          $domElement: this.$domElement.find("#support-and-info__support__form")
        }));
        /**/


        if (!window.location.hash) {
          window.location.hash = "general-conditions";
        }

        this.updateAccordion();
        /**/

        _get(_getPrototypeOf(SupportAndInfo.prototype), "init", this).call(this);
      }
    }, {
      key: "updateAccordion",
      value: function updateAccordion() {
        /*
         *  Change Tab
         */
        if (window.location.hash.match("support")) {
          this.$supportTab.tab('show');
        } else if (window.location.hash.match(this._genCondUrls)) {
          // this.$faqAccordion.find(".collapse").collapse("hide");
          this.$conditionsTab.tab('show');
        } else if (window.location.hash.match(this._faqUrls)) {
          this.$generalConditionsAccordion.find(".collapse").collapse("hide"); // this.$faqTab.tab('show');
        }
        /**/


        var $card = this.$domElement.find('.card[data-ref-hash="' + window.location.hash + '"]');

        if ($card.length) {
          var $collapse = $card.find('.collapse');
          $collapse.collapse('show');
        }
      }
    }, {
      key: "dispose",
      value: function dispose() {
        $(window).off("hashchange." + this.id).off("hashchange." + this.id);
        this.$tabNavA.off("click." + this.id);
        this.$toggleCollapse.off("click." + this.id);
        this.$collapse.off('shown.bs.collapse');

        _get(_getPrototypeOf(SupportAndInfo.prototype), "dispose", this).call(this);
      }
    }]);

    return SupportAndInfo;
  }(window.AbstractView);

  window.SupportAndInfo = SupportAndInfo;
})(window);
